import * as rmd from 'material-ui';
import React from "react";
import config from 'cfg';
import _ from "lodash";
import Promise from 'bluebird';
import { SliderPicker } from 'react-color';

class OverlayStyler extends React.Component {
    constructor(props, context) {
        super(props, context);


        var def = {}

        try {
            def = JSON.parse(props[props.propKey])
        } catch (e) {
            def = {
                opacity: 0.7,
                startColor: "#D10C0F",
                endColor: "#458734",
                gradient: "linear",
                position: "to bottom right"
            }
        }
        this.state = def;
    }

    componentWillReceiveProps(nextProps) {
        console.log("componentWillReceiveProps");
    }

    onOpacityChange = (e, val) => {
        this.setState({
            opacity: val
        }, this.notifyChanges);
        // var color = window.getComputedStyle(document.querySelector('.wdp.wdp_default .primary-color'), null).getPropertyValue('color');
        // console.log("COLOR", color);
    }
    onColorChange = (name, val, e) => {
        var o = {};
        o[name] = val.hex;
        this.setState(o, this.notifyChanges);
    }

    onChangeGradient = (e, val) => {
        this.setState({
            gradient: val,
            position: val == "radial" ? "center" : "to bottom right"
        }, this.notifyChanges);
    }
    onChangeGradientPosition = (e, val) => {
        this.setState({
            position: val
        }, this.notifyChanges);
    }

    notifyChanges = () => {
        this.props.onChange('overlayStyle', JSON.stringify({
            opacity: this.state.opacity,
            startColor: this.state.startColor,
            endColor: this.state.endColor,
            gradient: this.state.gradient,
            position: this.state.position,
        }));
        // var col
    }

    componentDidMount = () =>  {
        // var color = window.getComputedStyle(document.querySelector('.wdp.wdp_default .primary-color'), null).getPropertyValue('color');
        // console.log("COLOR", color);
    }

    getGradientsPosition = () => {
        return this.state.gradient == 'radial' ? ['center'] : [
            'to bottom right',
            'to bottom',
            'to bottom left',
            'to right',
            'to left',
            'to top right',
            'to top',
            'to top left'
        ]
    }

    render() {
        return (
            <div>
                <span>Overlay opacity</span>
                <rmd.Slider
                    step={0.10}
                    value={this.state.opacity}
                    onChange={this.onOpacityChange} />
                <span>Gradient type</span>

                <div className="wdp wdp_default">
                    <div className="primary-color"></div>
                </div>
                <rmd.RadioButtonGroup name="Gradient" valueSelected={this.state.gradient} onChange={this.onChangeGradient} style={{height: '24px', margin: '10px 0'}}>
                    <rmd.RadioButton
                       value="radial"
                       label="Radial"
                       style={{float: 'left', width: '50%'}}
                     />
                     <rmd.RadioButton
                        value="linear"
                        label="Linear"
                        style={{float: 'left', width: '50%'}}
                      />
                </rmd.RadioButtonGroup>
                <rmd.RadioButtonGroup name="Position" valueSelected={this.state.position} onChange={this.onChangeGradientPosition}>
                    {this.getGradientsPosition().map(p => {
                        return (<rmd.RadioButton
                               key={p}
                               value={p}
                               label={p}
                               style={{float: 'left', width: '50%'}}
                         />)
                    })}
                </rmd.RadioButtonGroup>

                <div style={{margin: '10px 0'}}>Gradinet start color</div>
                <SliderPicker disableAlpha={true} color={this.state.startColor} onChangeComplete={this.onColorChange.bind(this, 'startColor')} />
                <div style={{margin: '10px 0'}}>Gradinet stop color</div>
                <SliderPicker disableAlpha={true} color={this.state.endColor} onChangeComplete={this.onColorChange.bind(this, 'endColor')}  />

            </div>

        );
    }
}

export default OverlayStyler;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/OverlayStyler.js
 **/